<template>
  <div>
    <el-table
      :data="dataForm"
      stripe
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="tableHeard"
    >
      <el-table-column
        v-for="(item, index) in tableData"
        :key="index"
        :prop="item.key"
        :label="item.label"
        :width="item.width"
        align="center"
      >
        <template slot-scope="scope">
          <my-render v-if="item.render" :row="scope.row" :render="item.render"></my-render>
          <span v-else>{{scope.row[item.key] == '0' ? '0' : (scope.row[item.key] || '--')}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination__box" v-if="totalPage">
      <el-pagination
        layout="total, prev, pager, next"
        :total="totalPage.total"
        :page-size="totalPage.per_page"
        :current-page="totalPage.current_page"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import myRender from './myRender.vue'
export default {
  name: 'Table',
  components: { myRender },
  props: {
    tableData: {
      type: Array,
      default: []
    },
    dataForm: {
      type: Array,
      default: []
    },
    totalPage: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true
    },
    headerStyle: {
      type: String,
      default: 'background: #f4f4f4; text-align: center'
    },
  },
  data() {
    return {
      page: 1
    }
  },
  created() {},
  methods: {
    changePage(e) {
      this.$emit('changePage', e)
      window.scrollTo(0, 0)
    },
    //修改表头的样式
    tableHeard({ row, rowIndex }) {
      return this.headerStyle
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination__box {
  margin-top: 50px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Table/index.vue